import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTE_PREFIX} from '../routes/new-routes';

type InvitationType = 'team' | 'event';

export const useInvitationData = <T>(
  invitationCode: string | undefined,
  type: InvitationType
) => {
  const navigate = useNavigate();
  const [invitationData, setInvitationData] = useState<T>({} as T);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvitationData = async () => {
      try {
        // invitations are validated against the full code server-side
        const encodedCode = encodeURIComponent(invitationCode ?? '');
        const response = await fetch(`/invitation/${type}/${encodedCode}`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Forwarded-Proto': 'https',
          },
        });
        if (response.status === 404) {
          navigate(`${ROUTE_PREFIX}/invitation-invalid`, {replace: true});
          return;
        }
        if (!response.ok) {
          throw new Error(`Invitation request failed: ${response.status}`);
        }
        const data = (await response.json()) as T;
        setInvitationData(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch invitation data', {
          invitationCode,
          error,
        });
        navigate(`${ROUTE_PREFIX}/error`);
      } finally {
        setLoading(false);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchInvitationData();
  }, [invitationCode, type, navigate]);

  return {invitationData, loading};
};
